import { BodyMetricsOverview } from "../../../../../common/components/bodyMetrics/BodyMetricsOverview/BodyMetricsOverview";
import { useUserBodyMetricsPage } from "./hooks/useUserBodyMetricsPage";

/**
 * Staff page on a user's profile ("Метрики"): the exact view the user has on
 * "Моите метрики", scoped to that user. Staff can record and delete values too.
 */
export const UserBodyMetricsPage = () => {
  const { userName, dataSource } = useUserBodyMetricsPage();

  return <BodyMetricsOverview dataSource={dataSource} subtitle={userName} />;
};
